export default {
  title: 'Page Not Found',
  error: 'Error 404',
  message: 'There seems to be a problem. We couldn’t find the page you were looking for.',
  back: 'Go Back',
};
